import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, Select, MenuItem, Typography, Grid, Slide, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FilterListIcon from '@material-ui/icons/FilterList';
import { getRegistrationStatusText } from 'utils';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => {
  return {
    formControl: {
      minWidth: 200,
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  };
});

function SelectRegistrationStatus({ selectStatus, setSelectStatus }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [ open, setOpen ] = useState(false);

  const handleFilter = () => {
    setSelectStatus(' ');
    setOpen(!open);
  };

  return (
    <Grid item>

      <Grid container alignItems='center'>
        <Grid item>
          <IconButton
            type='button'
            onClick={ handleFilter }
          >
            {open ? <CloseIcon /> : <FilterListIcon />}
          </IconButton>
        </Grid>
        <Grid item>
          <Slide direction='right' in={ open } mountOnEnter unmountOnExit>
            <Grid container alignItems='center'>
              <Grid item>
                <Typography variant='subtitle1' color='textPrimary'>
                  Status:
                </Typography>
              </Grid>
              <Grid item>
                <FormControl className={ classes.formControl }>
                  <Select
                    variant='outlined'
                    color='secondary'
                    id='relation-select'
                    style={ { height: 40 } }
                    value={ selectStatus }
                    onChange={ (e) => {
                      setSelectStatus(e.target.value);
                    } }
                  >
                    <MenuItem value=' '>
                      <em>{t('all')}</em>
                    </MenuItem>
                    <MenuItem value='sample_pending'>{t(getRegistrationStatusText('sample_pending'))}</MenuItem>
                    <MenuItem value='registration_done'>{t(getRegistrationStatusText('registration_done'))}</MenuItem>
                    <MenuItem value='sample_received'>{t(getRegistrationStatusText('sample_received'))}</MenuItem>
                    <MenuItem value='analysis'>{t(getRegistrationStatusText('analysis'))}</MenuItem>
                    <MenuItem value='done'>{t(getRegistrationStatusText('done'))}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Slide>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SelectRegistrationStatus;
